import { render, staticRenderFns } from "./SetUpFile.vue?vue&type=template&id=3f0364fc&scoped=true"
import script from "./SetUpFile.vue?vue&type=script&lang=js"
export * from "./SetUpFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0364fc",
  null
  
)

export default component.exports